import { Typography } from "@mui/material"
import React from "react"

export interface ITextInputProps {
  label: string
}

export function SubtitleFormTypography({ label }: Readonly<ITextInputProps>): React.JSX.Element {
  return <Typography variant="subtitle1">{label}</Typography>
}
